import { Flex, Stack, Image, VStack, Heading, Text, Button, useMediaQuery, chakra } from '@chakra-ui/react';
import React from 'react';
import EarnPointToSpend from 'Assets/Images/EarnPointToSpend.png';
import useLocalizedNavigate from 'Utils/useLocalizedNavigate';
import { AppRoutes } from 'Routes/AppRoutes';
import { ILoopLandingPageLocalizationDocument } from 'Types/Interface/Sanity';

interface IEarnToSpendProps{
	loopLandingPageLocalization: ILoopLandingPageLocalizationDocument | null;
}

export const EarnToSpend = ({loopLandingPageLocalization}:IEarnToSpendProps) => {
	const navigate  = useLocalizedNavigate();
	const [isLargerThan768] = useMediaQuery('(min-width: 900px)');
	return(
		<Flex direction={['column', null, null,  'row']}  justifyContent={'space-between'} >
			<Stack align={'start'} spacing={['30px','40px']} mt={['null','30px']}>
				<VStack align={'start'} spacing={['30px','20px']}>
					<Heading textTransform={'uppercase'} fontSize={['30px','40px']} w={['full','600px']}>{loopLandingPageLocalization?.earnRewardTitlePart1} <chakra.span color={'darkCoral'}>{loopLandingPageLocalization?.earnRewardTitleHighlight}</chakra.span></Heading>
					{/* <Text fontSize={['18px', '20px']} fontWeight={600} color={'#2B2B2B;'}>Join a Community of Like-Minded Fans</Text> */}
					<Text fontSize={['16px','18px']} w={['auto', null, null, '480px', '80%']} >
						{loopLandingPageLocalization?.earnRewardDescription}
					</Text>
					
					{ !isLargerThan768 && <Image src={EarnPointToSpend} boxSize={'100%'}  objectFit={'contain'} />}
				</VStack>
				<VStack align={'start'} spacing={'20px'}>
					<Heading textTransform={'uppercase'} fontSize={['18px','20px']}>{loopLandingPageLocalization?.earnOnInteractionTitle}</Heading>
					<Text  fontSize={['16px','18px']} w={['auto', null, null, '480px', '80%']} >
						{loopLandingPageLocalization?.earnOnInteractionDescription}
					</Text>
				</VStack>
				<VStack align={'start'} spacing={'20px'}>
					<Heading textTransform={'uppercase'} fontSize={['18px','20px']}>{loopLandingPageLocalization?.spendAnywhereTitle}</Heading>
					<Text fontSize={['16px','18px']} w={['auto', null, null, '480px', '80%']}>
						{loopLandingPageLocalization?.spendAnywhereDescription}
					</Text>
				</VStack>
				<Button variant={'secondary'} onClick={() => navigate(AppRoutes.register)} w={['150px','170px']} h={['50px','60px']}>Sign up now!</Button>
			</Stack>
			{isLargerThan768 && <Image 
				src={EarnPointToSpend} 
				boxSize={{ base: '100%', md: '100%', lg: '40%' }}
				mt={{md:'30px'}}
				objectFit="cover"
			/>}
		</Flex>
	);
};